export default {
  notifications: [],

  message: '',
  color: '',
  timer: '',
  icon: ''
};
